// extracted by mini-css-extract-plugin
export default {"EnteteColonne":"EnteteColonne_EnteteColonne__8lrhr"};